export default __webpack_public_path__ + "static/media/logo-footer.6fcaa650.svg";